// Decisão pura do destino de um cartão solto no quadro (RQ-EST-003, RQ-EST-009, RQ-EST-010).

import type { Ponto } from './camera';
import type { Retangulo } from './grupos';

export type GrupoAlvo = Retangulo & { uuid: string; estadoUuid: string };

export type Soltura = {
  /** Retângulo do cartão no quadro (coordenadas absolutas) no instante em que foi solto. */
  cartao: Retangulo;
  /** O ponteiro estava sobre o ícone da Lixeira. */
  sobreLixeira: boolean;
  estadoAtualUuid: string;
  semEstadoUuid: string;
  /** Na ordem em que são desenhados: o último fica por cima. */
  grupos: GrupoAlvo[];
};

export type DestinoSoltura =
  | { tipo: 'lixeira' }
  | { tipo: 'mesmo-grupo'; grupoUuid: string; posicao: Ponto }
  | { tipo: 'outro-grupo'; grupoUuid: string; estadoUuid: string; posicao: Ponto }
  | { tipo: 'sem-estado' }
  | { tipo: 'nenhum' };

/** Folga em volta do ícone da Lixeira que já aceita o cartão (o ícone é pequeno e transparente). */
export const MARGEM_LIXEIRA = 32;

/** Ponto da tela dentro do retângulo de um elemento, aumentado pela margem em todos os lados. */
export function pontoNaArea(r: { left: number; right: number; top: number; bottom: number } | null | undefined, p: Ponto | null, margem = 0) {
  return !!r && !!p && p.x >= r.left - margem && p.x <= r.right + margem && p.y >= r.top - margem && p.y <= r.bottom + margem;
}

const contem = (r: Retangulo, p: Ponto) => p.x >= r.x && p.x <= r.x + r.largura && p.y >= r.y && p.y <= r.y + r.altura;

/**
 * A Lixeira vence; depois, o grupo (de cima) sob o centro do cartão — o estado do grupo é o estado do cartão;
 * fora de qualquer grupo, o cartão vai para Sem estado (a tela pede confirmação antes).
 * A posição devolvida é relativa ao grupo, como é gravada.
 */
export function decidirSoltura(s: Soltura): DestinoSoltura {
  if (s.sobreLixeira) return { tipo: 'lixeira' };
  const centro = { x: s.cartao.x + s.cartao.largura / 2, y: s.cartao.y + s.cartao.altura / 2 };
  const grupo = s.grupos.findLast((g) => contem(g, centro));
  if (!grupo) return s.estadoAtualUuid === s.semEstadoUuid ? { tipo: 'nenhum' } : { tipo: 'sem-estado' };
  const posicao = { x: s.cartao.x - grupo.x, y: s.cartao.y - grupo.y };
  if (grupo.estadoUuid === s.estadoAtualUuid) return { tipo: 'mesmo-grupo', grupoUuid: grupo.uuid, posicao };
  return { tipo: 'outro-grupo', grupoUuid: grupo.uuid, estadoUuid: grupo.estadoUuid, posicao };
}
